import { injectIntl } from 'react-intl';
import Assisted from './Assisted';
import config from './config';

export const CONFIG = config;

export default injectIntl(Assisted);
